module.exports = __webpack_public_path__ + "img/sorexpay.f01e0fa0.svg";